<div class="blank-layout-container">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-10 col-md-12">
        <div class="privacy-policy-wrapper">
          <div class="privacy-policy-header">
            <h1 class="policy-title">AutoGizmo Privacy Policy</h1>
            <p class="policy-subtitle">Last Updated: 29th January, 2026</p>
          </div>
          
          <div class="privacy-policy-content">
            
            <!-- Introduction Section -->
            <section class="policy-section">
              <h2 class="section-title">1. Introduction</h2>
              <p class="section-content">
                Welcome to AutoGizmo. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our service platform. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the platform.
              </p>
            </section>

            <!-- Information We Collect Section -->
            <section class="policy-section">
              <h2 class="section-title">2. Information We Collect</h2>
              <h3 class="subsection-title">2.1 Personal Information</h3>
              <p class="section-content">
                We may collect personal information that you voluntarily provide to us when you:
              </p>
              <ul class="policy-list">
                <li>Register for an account</li>
                <li>Use our services</li>
                <li>Contact us for support</li>
                <li>Participate in surveys or promotions</li>
              </ul>
              
              <h3 class="subsection-title">2.2 Automatically Collected Information</h3>
              <p class="section-content">
                When you access our platform, we may automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device.
              </p>
            </section>

            <!-- How We Use Your Information Section -->
            <section class="policy-section">
              <h2 class="section-title">3. How We Use Your Information</h2>
              <p class="section-content">
                We use the information we collect to:
              </p>
              <ul class="policy-list">
                <li>Provide, maintain, and improve our services</li>
                <li>Process transactions and send related information</li>
                <li>Send you technical notices and support messages</li>
                <li>Respond to your comments and questions</li>
                <li>Monitor and analyze trends and usage</li>
                <li>Detect, prevent, and address technical issues</li>
              </ul>
            </section>

            <!-- Information Sharing Section -->
            <section class="policy-section">
              <h2 class="section-title">4. Information Sharing and Disclosure</h2>
              <p class="section-content">
                We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
              </p>
              <ul class="policy-list">
                <li>With service providers who assist us in operating our platform</li>
                <li>When required by law or to respond to legal process</li>
                <li>To protect our rights and the safety of our users</li>
                <li>In connection with a business transfer or merger</li>
              </ul>
            </section>

            <!-- Data Security Section -->
            <section class="policy-section">
              <h2 class="section-title">5. Data Security</h2>
              <p class="section-content">
                We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <!-- Your Rights Section -->
            <section class="policy-section">
              <h2 class="section-title">6. Your Rights</h2>
              <p class="section-content">
                Depending on your location, you may have certain rights regarding your personal information, including:
              </p>
              <ul class="policy-list">
                <li>The right to access your personal information</li>
                <li>The right to correct inaccurate information</li>
                <li>The right to request deletion of your information</li>
                <li>The right to object to processing of your information</li>
                <li>The right to data portability</li>
              </ul>
            </section>

            <!-- Cookies Section -->
            <section class="policy-section">
              <h2 class="section-title">7. Cookies and Tracking Technologies</h2>
              <p class="section-content">
                We use cookies and similar tracking technologies to track activity on our platform and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
              </p>
            </section>

            <!-- Third-Party Links Section -->
            <section class="policy-section">
              <h2 class="section-title">8. Third-Party Links</h2>
              <p class="section-content">
                Our platform may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review the privacy policies of any third-party sites you visit.
              </p>
            </section>

            <!-- Children's Privacy Section -->
            <section class="policy-section">
              <h2 class="section-title">9. Children's Privacy</h2>
              <p class="section-content">
                Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us.
              </p>
            </section>

            <!-- Changes to Privacy Policy Section -->
            <section class="policy-section">
              <h2 class="section-title">10. Changes to This Privacy Policy</h2>
              <p class="section-content">
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
              </p>
            </section>

            <!-- Contact Us Section -->
            <section class="policy-section">
              <h2 class="section-title">11. Contact Us</h2>
              <p class="section-content">
                If you have any questions about this Privacy Policy, please contact us:
              </p>
              <div class="contact-info">
                <p><strong>Email:</strong> info&#64;auto-gizmo.com</p>
                <p><strong>Phone:</strong> +254 720 730814</p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
